/* eslint-disable */
<template>
  <div>
    <div class="container-fluid no-padding">
      <div class="row toolbox-fixed">
        <div class="col-md-6 mb-2 mt-2">
          <input class="form-control block btn-more-radius" @keyup.enter="getUrunCikislari()" v-model="searchFilter"
            type="text" placeholder="IMEI, HDD, Bayii, Müşteri, Notunuza göre arama yapın...">
        </div>
        <div class="col-md-6 mb-2 mt-2">
          <button role="button" @click="bayiiStokAktar()"
            v-if="canExportDeviceToRetailer && withContext"
            class="btn btn-more-radius btn-primary">
            Bayii Stoğuna Aktar
          </button>
          <button role="button" @click="musteriHesabinaKaydet()"
            v-if="canAddDeviceToCustomer && withContext"
            class="btn btn-more-radius btn-danger">
            Müşteri Hesabına Kaydet
          </button>
          <button class="btn btn-outline-primary btn-more-radius dropdown-toggle" type="button"
            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Toplu İşlemler
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" role="button" data-toggle="modal" data-target="#modalMultipleWaybill">
              Seçilenlere İrsaliye / Fatura Numarası Ayarla</a>
          </div>
          <router-link to="/urun-cikislari/gonderi-yap" role="button"
            :disabled="!canInsertUrunCikis"
            class="btn btn-more-radius btn-success float-right">
            Ürün Çıkışı Yap
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="cikislar-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Ürün Çıkışları Yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="align-middle" style="width: 1%;" scope="col">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="selectAll" id="checkAllUcks">
                      <label class="custom-control-label" for="checkAllUcks"></label>
                    </div>
                  </th>
                  <th style="width: 1%;" scope="col">##</th>
                  <th style="width: 6%;" scope="col">ÇIKIŞ</th>
                  <th class="" style="width: 12%;" scope="col">CİHAZ SERİ NO</th>
                  <th class="" style="width: 10%;" scope="col">HDD / GSM</th>
                  <th style="width: 12%;" scope="col">BAYİİ</th>
                  <th style="width: 8%;" scope="col">İRSALİYE</th>
                  <th style="width: 13%;" scope="col">KAYIT NOTU</th>
                  <th style="width: 9%;" scope="col">KAYDEDEN</th>
                  <th scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(urun, index) in urunler">
                  <tr :key="'trow-first-' + urun.OUT_ID">
                    <td class="align-middle" style="width: 1%;">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :value="urun.OUT_ID"
                          v-model="selectedUckList" v-bind:id="'tcheck-'+urun.OUT_ID">
                        <label class="custom-control-label" v-bind:for="'tcheck-'+urun.OUT_ID"></label>
                      </div>
                    </td>
                    <td class="align-middle" style="width: 1%;">{{index+1}}</td>
                    <td class="align-middle" style="width: 6%;" scope="row">{{urun.OUT_DATE_FORMATTED}}</td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 12%;">
                      <div>
                        <p class="my-0 font-weight-bold">{{urun.OUT_DEVICE_ID}}</p>
                        <small class="mt-1">{{urun.OUT_DEVICE_LABEL || 'CİHAZ MODELİ TANIMSIZ'}}</small>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 10%;">
                      <div>
                        <p class="my-0 font-weight-bold">{{urun.OUT_HDD || urun.OUT_GSM}}</p>
                        <small v-if="urun.OUT_HDD" class="mt-1">{{urun.OUT_HDD_BRAND}}  -  {{urun.OUT_HDD_CAPACITY}}</small>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 12%;">
                      <p class="my-0 font-weight-bold">{{urun.RETAILER_NAME}}</p>
                      <small>{{formatTitle(urun.CUSTOMER_TITLE) || 'MÜŞTERİ TANIMSIZ'}}</small>
                    </td>
                    <td class="align-middle" style="width: 8%;">{{urun.OUT_WAYBILL_CODE}}</td>
                    <td class="align-middle" style="width: 13%;">
                      <span class="text-truncate" :data-toggle2="urun.OUT_NOTE != undefined && urun.OUT_NOTE.length > 40 ? 'tooltip' : ''"
                        data-placement="bottom" :title="urun.OUT_NOTE">{{formatNote(urun.OUT_NOTE)}}</span>
                    </td>
                    <td class="align-middle" style="width: 9%;">{{urun.PERSONEL_NAME}}</td>
                    <td class="align-middle text-center">
                      <button :disabled="!canUpdateUrunCikis" class="btn btn-outline-primary btn-more-radius" @click="openModalForUpdateDelete(index, 0)"
                        data-toggle="modal" data-target="#insertUrunCikisModal" aria-expanded="false">
                        <i class="far fa-edit text-primary"></i>&nbsp;&nbsp;Düzenle</button>
                      <button class="btn btn-outline-danger btn-more-radius" @click="openModalForUpdateDelete(index, 1)" :disabled="!canDeleteUrunCikis"
                        data-toggle="modal" data-target="#insertUrunCikisModal" aria-expanded="false">
                        <i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;Kaydı Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canInsertUrunCikis || canUpdateUrunCikis || canDeleteUrunCikis" class="modal fade bd-example-modal-lg" id="insertUrunCikisModal" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="modalOpenFor == 0" class="modal-title" id="trackNumberModalLabel">{{selectedUrunCikis ? 'Ürün Çıkış Kaydını Güncelle' : 'Ürün Çıkış Kaydı Oluştur'}}</h5>
            <h5 v-if="modalOpenFor == 1" class="modal-title" id="trackNumberModalLabel">Ürün çıkış kaydını silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="uruncikis-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>{{ modalOpenFor == 1 ? 'Ürün Çıkışı Kaydediliyor...' : 'Kayıt siliniyor...'}}</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-kod">Çıkış Tarihi</label>
                    <datepicker id="malzeme-kod" :disabled="modalOpenFor == 1"
                      :bootstrap-styling="true" v-model="urunCikisKaydi.OUT_DATE"
                      :format="dateFormatter"></datepicker>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-tur">Cihaz Seri No</label>
                    <input type="text" class="form-control" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_DEVICE_ID" id="malzeme-tur">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-detail">Müşteri</label>
                    <autocomplete id="malzeme-detail" v-model="customerSearchFilter" :inputClass="'loading'"
                      :serializer="item => item.CUSTOMER_TITLE" :minMatchingChars='3' :disabled="modalOpenFor == 1"
                      :data="foundCustomers" placeholder="Müşteri..."
                      @hit="selectedCustomer = $event" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-adi">HDD Seri No</label>
                    <input type="text" class="form-control" placeholder="HDD seri numarası" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_HDD" >
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="out-hdd-brand">HDD Markası</label>
                    <select class="custom-select mr-sm-2" id="out-hdd-brand" :disabled="modalOpenFor == 1"  v-model="urunCikisKaydi.OUT_HDD_BRAND">
                      <option value="Marka" selected>Marka seçiniz...</option>
                      <option value="Western Digital">Western Digital</option>
                      <option value="Seagate">Seagate</option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="out-hdd-cap">HDD Kapasitesi</label>
                    <select class="custom-select mr-sm-2" id="out-hdd-cap" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_HDD_CAPACITY">
                      <option value="0" selected>Kapasite seçiniz...</option>
                      <option value="1 TB">1 TB</option>
                      <option value="500 GB">500 GB</option>
                      <option value="4 TB">4 TB</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="out-retailer">Bayii</label>
                    <select class="custom-select mr-sm-2" id="out-retailer" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_RETAILER">
                      <option value="0" selected>Bayii seçiniz...</option>
                      <option value="1">LENOİ</option>
                      <option value="2">NOKKON</option>
                      <option value="3">ZİMİR</option>
                      <option value="4">İNTERGLOBAL</option>
                      <option value="5">BÜLENT EŞKİ</option>
                      <option value="6">AROMİL</option>
                      <option value="9">SECAN GÜVENLİK</option>
                      <option value="10">CANTEL ELEKTRONİK</option>
                      <option value="11">PTT</option>
                      <option value="13">ASİS ELEKTRONİK</option>
                      <option value="14">DCA</option>
                      <option value="15">NOKITECH</option>
                      <option value="16">FİLOSİSTEM</option>
                      <option value="17">SEZGİN KOÇ</option>
                      <option value="18">DİĞER</option>
                    </select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-mancode">Hat Gsm No</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-mancode" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_GSM" />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-mancode">İrsaliye / Fatura No</label>
                    <input type="text" class="form-control" rows="4" id="malzeme-mancode" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_WAYBILL_CODE" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-supplier">Ürün Çıkış Notu</label>
                    <textarea rows="4" class="form-control" id="malzeme-supplier" :disabled="modalOpenFor == 1" v-model="urunCikisKaydi.OUT_NOTE"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" v-if="modalOpenFor == 0" @click="insertUrunCikis()" class="btn btn-primary">Ürün Çıkış Kaydını Tamamla</button>
            <button type="button" v-if="modalOpenFor == 1" @click="deleteUrunCikis()" class="btn btn-danger">Ürün Çıkış Kaydını Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg"  id="modalMultipleWaybill" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Toplu irsaliye / fatura numarası girişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="mutliple-waybill-setting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>İrsaliye Numaraları ayarlanıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="multiple-waybill-code">İrsaliye ve ya Fatura Numarasını Girin</label>
                    <input type="text" id="multiple-waybill-code"
                      placeholder="İrsaliye - Fatura No"
                      v-model="multipleWaybill" class="form-control" />
                    <small class="form-text text-muted">Girdiğiniz bilgi, seçtiğiniz bütün kayıtlara uygulanacaktır. Eğer seçtiğiniz kayıtlarda daha önce bir irsaliye/fatura bilgisi girişi yaptıysanız bu bilgi kaybolacaktır.</small>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setMultipleWaybill()" class="btn btn-danger">Seçilen kayıtları güncelle</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {tr} from 'vuejs-datepicker/dist/locale'
import autocompl from 'vue-bootstrap-typeahead'
import _ from 'lodash'

export default {
  name: 'CikislarPage',
  components: {
    'datepicker': Datepicker,
    'autocomplete': autocompl
  },
  data () {
    return {
      contextId: '',
      tr: "tr",
      searchFilter: '',
      urunler: [],
      urunCikisKaydi: {
        OUT_HDD_BRAND: "Marka",
        OUT_HDD_CAPACITY: "0",
        OUT_RETAILER: "0",
        OUT_DATE: ""
      },
      backupUck: {},
      customerSearchFilter: '',
      foundCustomers: [],
      selectedCustomer: {},
      selectedUrunCikis: {},
      modalOpenFor: 0,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
      selectedUckList: [],
      multipleWaybill: ''
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canInsertUrunCikis : function() { return this.$store.getters.userCanInsertUrunCikis },
    canUpdateUrunCikis : function() { return this.$store.getters.userCanUpdateUrunCikis },
    canDeleteUrunCikis : function() { return this.$store.getters.userCanDeleteUrunCikis },
    canAddDeviceToCustomer : function() { return this.$store.getters.userCanAddDeviceToCustomer },
    canExportDeviceToRetailer : function() { return this.$store.getters.userCanExportDeviceToRetailer},
    withContext: function() { return this.contextId != null && this.contextId.length == 32 },
    isMultipleUckSelected: function () { return this.selectedUckList.length > 0 },
    selectAll: {
      get: function () {
        return this.selectedUckList ? this.urunler.length == this.selectedUckList.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.urunler.forEach(function (urun) {
            selected.push(urun.OUT_ID);
          });
        }
        this.selectedUckList = selected;
      }
    }    
  },
  methods: {
    getUrunCikislari() {
      if(this.$route.params.id !== undefined)
        this.contextId = this.$route.params.id

      this.$wait.start('cikislar-loading')
      axios.post('/api/uruncikis/tum-kayitlar?sessionid=' 
        + this.getSessionId + '&searchFilter=' + this.searchFilter + '&contextId=' + this.contextId)
      .then(response => {
        this.urunler = response.data
        this.$wait.end('cikislar-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('cikislar-loading')
      })
    },
    insertUrunCikis() {
      this.$wait.start('uruncikis-inserting')
      this.urunCikisKaydi.SessionId = this.getSessionId
      this.urunCikisKaydi.OUT_CUSTOMER = this.selectedCustomer.CUSTOMER_ID

      axios.post("/api/uruncikis/gonderi-yap", this.urunCikisKaydi)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Ürün çıkış kaydı ' + (this.selectedUrunCikis ? 'güncellendi' : 'eklendi'), this.toastOptions)      
        else
          this.$toasted.error('Kayıt eklenemedi. Durum mesajı: ' + response.data.ErrorMessage)

        this.$wait.end('uruncikis-inserting')
        $('#insertUrunCikisModal').modal('hide')

        this.getUrunCikislari()
        this.selectedCustomer = {}
        this.foundCustomers = []
        this.customerSearchFilter = ''
      }).catch(error => console.log(error))
    },
    deleteUrunCikis() {
      this.$wait.start('uruncikis-inserting')
      console.log(this.selectedUrunCikis);
      console.log(this.selectedUrunCikis.OUT_ID)

      axios.post("/api/uruncikis/gonderi-sil?outId=" + this.selectedUrunCikis.OUT_ID)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Ürün çıkış kaydı silindi', this.toastOptions)
        else
          this.$toasted.error('Kayıt silinemedi. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)
        
        this.$wait.end('uruncikis-inserting')
        $('#insertUrunCikisModal').modal('hide')

        this.getUrunCikislari()
        this.selectedCustomer = {}
        this.foundCustomers = []
        this.customerSearchFilter = ''
      }).catch(error => console.log(error))
    },
    bayiiStokAktar() {
      this.$wait.start('uruncikis-inserting')

      axios.post("/api/uruncikis/bayii-stok-aktar?SessionId="+ this.getSessionId + "&ContextId=" + this.contextId)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Cihazlar bayii stoğuna aktarıldı.', this.toastOptions)      
        else
          this.$toasted.error('Cihazlar bayii stoğuna aktarılamadı. Hata: ' + response.data.ErrorMessage)

        this.$wait.end('uruncikis-inserting')
        this.$router.push('/urun-cikislari')
      }).catch(error => console.log(error))
    },
    musteriHesabinaKaydet() {
      this.$wait.start('uruncikis-inserting')

      axios.post("/api/uruncikis/musteri-hesabina-kaydet?SessionId=" + this.getSessionId + "&ContextId=" + this.contextId)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Cihazlar müşteri hesabına aktarıldı.', this.toastOptions)      
        else
          this.$toasted.error('Cihazlar müşteri hesabına kaydedilemedi. Hata: ' + response.data.ErrorMessage)

        this.$wait.end('uruncikis-inserting')
        this.$router.push('/urun-cikislari')
      }).catch(error => console.log(error))
    },
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatTitle(title) {
      if(title && title.length > 30)
        return title.substring(0, 27) + "..."
      else return title
    },
    formatNote(title) {
      if(title && title.length > 40)
        return title.substring(0, 35) + "..."
      else return title
    },
    openModalForUpdateDelete(index, openFor) {
      this.modalOpenFor = openFor
      this.selectUrunCikis(index)
      this.urunCikisKaydi = this.selectedUrunCikis
    },
    openModalForInsert() {
      this.modalOpenFor = 0
      this.selectedUrunCikis = {}
      console.log(this.backupUck)
      this.urunCikisKaydi = this.backupUck
    },
    selectUrunCikis(index) {
      this.selectedUrunCikis = this.urunler[index]
      this.customerSearchFilter = this.selectedUrunCikis.CUSTOMER_TITLE
      this.selectedCustomer.CUSTOMER_ID = this.selectedUrunCikis.OUT_CUSTOMER
      this.selectedCustomer.CUSTOMER_TITLE = this.selectedUrunCikis.CUSTOMER_TITLE
    },
    async getCustomersByText(query) {
      if(!query || query.length < 4)
        return

      let jsonReq = {}
      jsonReq.SessionId = this.getSessionId
      jsonReq.SearchFilter = query
      await axios.post('/api/uruncikis/musteri-ara?sessionid=' + jsonReq.SessionId + "&searchFilter=" + jsonReq.SearchFilter, jsonReq)
      .then(response => this.foundCustomers = response.data)
      console.log(this.foundCustomers)
    },
    setMultipleWaybill() {
      if(this.selectedUckList.length == 0) {
        this.$toasted.info('Listenizden hiç kayıt seçmediniz !', this.toastOptions)
        return;
      }

      if(this.multipleWaybill == null || this.multipleWaybill == undefined || this.multipleWaybill.length == 0) {
        this.$toasted.info('İrsaliye ve ya fatura numarası girmediniz !', this.toastOptions)
        return;
      }

      this.$wait.start('mutliple-waybill-setting')

      axios.post('/api/uruncikis/toplu-irsaliye-girisi?SessionId=' 
        + this.getSessionId + "&Cikislar=" + this.selectedUckList + "&WaybillCode=" + this.multipleWaybill)
      .then(resp => {
        if(resp.data.HasError == false)
          this.$toasted.success('İşlem başarılı', this.toastOptions)
        else
          this.$toasted.error('İşlem yapılamadı. Durum: ' + resp.data.ErrorMessage, this.toastOptions)

        $("#modalMultipleWaybill").modal('hide')
        this.$wait.end('mutliple-waybill-setting')
        this.selectedUckList = [];
        this.getUrunCikislari()
      })
      .catch(error => {
        $("#modalMultipleWaybill").modal('hide')
        this.$toasted.error('İşlem yapılamadı', this.toastOptions)
        this.$wait.end('mutliple-waybill-setting')
      })
    }
  },
  watch: {
    customerSearchFilter: _.debounce(function(val) { this.getCustomersByText(val) }, 500),
    '$route.params.id': function() { this.getUrunCikislari() }
  },
  beforeMount() {
    moment.locale('tr')
  },
  mounted() {
    this.backupUck = this.urunCikisKaydi
    this.getUrunCikislari()
  }
}
</script>

<style scoped>

  html, body {
    overflow-x: hidden;
  }

  .thead-fixed {
    table-layout: fixed;
    overflow: hidden;
    width: 100%;
    position: fixed;
    z-index: 98;
    top: 113px;
  }

  .thead-fixed tx {
    padding-left: 10%;
    padding-right: 10%;
  }

  .toolbox-fixedx {
    overflow: hidden;
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 61px;
    background-color: #F0F0F0;
  }

  table {
    margin-top: 0px;
  }

  input[type="text"].loading, input[type="search"].loading {
    background-image: url("~/static/loading.svg");
    background-size: 32px 32px;
    background-position:right center;
    background-repeat: no-repeat;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .header-fixed {
    position: absolute;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .lh-condensed { line-height: 1.25; } 

  p { display: block;}

  .text-truncate {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/CikislarPage.vue